import { $ScrollLockModuleName } from "@/redux/modules/value/scrollLock/scrollLock.types";
import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

const isLocked = (state: IState) =>
    getValueState(state, $ScrollLockModuleName)?.lockedDiscriminators?.length;

const isLockedFor = (discriminator: string) => (state: IState) =>
    !!getValueState(state, $ScrollLockModuleName)?.lockedDiscriminators?.some(
        (d) => d === discriminator
    );

export { isLocked, isLockedFor };
